import { AnimaAuth } from './auth';
import { getGlobalPlaygroundAPIBaseURL } from './urls';

export type AnimaAPIParams = {
  animaAuth: AnimaAuth;

  // Optional overrides
  playgroundId?: string;
  playgroundAPIBaseURL?: string;
  customAuthCallback?: (options: RequestInit) => RequestInit;
};

export class AnimaAPI {
  constructor(private readonly params: AnimaAPIParams) {}

  async fetchAPI(endpoint: string, options: RequestInit) {
    const url = `${this.$getPlaygroundAPIBaseURL()}/${this.$getPlaygroundId()}${endpoint}`;

    if (this.params.customAuthCallback) {
      options = this.params.customAuthCallback(options);
    } else {
      const authToken = await this.params.animaAuth.$getToken();

      options.headers = {
        ...options.headers,
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      };
    }

    return fetch(url, options);
  }

  $getPlaygroundAPIBaseURL(): string {
    if (this.params.playgroundAPIBaseURL) {
      return this.params.playgroundAPIBaseURL;
    }

    return getGlobalPlaygroundAPIBaseURL();
  }

  $getPlaygroundId(): string {
    if (this.params.playgroundId) {
      return this.params.playgroundId;
    }

    if (typeof window !== 'undefined' && window.__ANIMA_PLAYGROUND_ID__) {
      return window.__ANIMA_PLAYGROUND_ID__;
    }

    throw new Error('Playground ID is not set in window.__ANIMA_PLAYGROUND_ID__');
  }
}
